import { render, staticRenderFns } from "./AddToken.vue?vue&type=template&id=55df6986&scoped=true&"
import script from "./AddToken.vue?vue&type=script&lang=ts&"
export * from "./AddToken.vue?vue&type=script&lang=ts&"
import style0 from "./AddToken.vue?vue&type=style&index=0&id=55df6986&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df6986",
  null
  
)

export default component.exports